import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { Sparkles, ArrowRight } from "lucide-react";

const isExternal = (href = "") => /^https?:\/\//i.test(href);

const OfferButton = ({ offer, ctaOverride }) => {
  const cls = "inline-flex items-center justify-center gap-2 bg-[#0A0A0A] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0A0A0A] transition-colors px-6 py-3 text-xs sm:text-sm uppercase tracking-wider font-semibold w-full sm:w-auto";
  const label = offer.button_text || "Je profite de l'offre";
  if (ctaOverride) {
    return <a href={ctaOverride} className={cls} data-testid={`offer-cta-${offer.id}`}>{label} <ArrowRight size={16} /></a>;
  }
  if (isExternal(offer.button_link)) {
    return <a href={offer.button_link} target="_blank" rel="noreferrer" className={cls} data-testid={`offer-cta-${offer.id}`}>{label} <ArrowRight size={16} /></a>;
  }
  return <Link to={offer.button_link || "/gestion"} className={cls} data-testid={`offer-cta-${offer.id}`}>{label} <ArrowRight size={16} /></Link>;
};

export const OfferBanner = ({ ctaOverride }) => {
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    axios.get(`${API}/offers/active`).then((r) => setOffers(r.data)).catch(() => setOffers([]));
  }, []);

  if (!offers.length) return null;

  return (
    <div className="space-y-4" data-testid="offer-banner">
      {offers.map((offer) => (
        <div
          key={offer.id}
          className="relative mx-auto max-w-4xl bg-white/95 backdrop-blur border border-[#D4AF37] shadow-[0_20px_60px_-20px_rgba(0,0,0,0.35)] text-left"
          data-testid={`offer-card-${offer.id}`}
        >
          <div className="absolute -top-3 left-6 bg-[#D4AF37] text-[#0A0A0A] text-[10px] sm:text-xs font-bold uppercase tracking-[0.2em] px-3 py-1 flex items-center gap-1">
            <Sparkles size={12} /> Offre de lancement
          </div>
          <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-4 md:gap-8 items-center px-5 sm:px-8 pt-7 pb-5 sm:pb-6">
            <div className="min-w-0">
              <p className="font-serif text-lg sm:text-xl md:text-2xl text-[#0A0A0A] leading-snug" data-testid="offer-title">{offer.title}</p>
              {offer.description && (
                <p className="text-gray-700 text-sm sm:text-base mt-1" data-testid="offer-description">{offer.description}</p>
              )}
              {offer.highlight && (
                <p className="mt-3 flex flex-wrap items-baseline gap-x-2 gap-y-1" data-testid="offer-highlight">
                  <span className="font-serif font-bold text-3xl sm:text-4xl text-[#B8952B] leading-none">{offer.highlight.split(" au lieu de ")[0]}</span>
                  {offer.highlight.includes(" au lieu de ") && (
                    <span className="text-sm sm:text-base text-gray-500">au lieu de <span className="line-through">{offer.highlight.split(" au lieu de ")[1]}</span></span>
                  )}
                </p>
              )}
              {offer.conditions && (
                <p className="text-xs sm:text-sm text-gray-600 mt-2" data-testid="offer-conditions">{offer.conditions}</p>
              )}
            </div>
            <div className="md:self-center">
              <OfferButton offer={offer} ctaOverride={ctaOverride} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OfferBanner;
